import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Row,
  Typography,
  Tag,
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  DatePicker,
  message,
} from "antd";
import moment from "moment";
import { getInventoryApi, updateInventoryApi } from "../../services/InventoryApi";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const { Title, Text } = Typography;
const { Option } = Select;

const ViewInventory = () => {
  const [inventory, setInventory] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [form] = Form.useForm();
let {companyId} = useParams()
  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    try {
      const res = await getInventoryApi({companyId});
      setInventory(res || []);
    } catch (err) {
      console.error("Error fetching inventory", err);
    }
  };

  const isExpiringSoon = (item) => {
    const expiryDate = moment(item.createdAt).add(item.duration, "months");
    const daysLeft = expiryDate.diff(moment(), "days");
    return daysLeft <= 10;
  };

  const handleRestockClick = (item) => {
    setSelectedItem(item);
    form.setFieldsValue({
      ...item,
    });
    setOpenDrawer(true);
  };

  const handleUpdate = async (values) => {
    try {
    let res =   await updateInventoryApi(values,selectedItem._id );
      if(res?.message) return toast.error(res?.message||'Not Updated !')
        toast.success('Updated sucessfully!')
      setOpenDrawer(false);
      fetchInventory();
    } catch (err) {
      console.error(err);
      message.error("Failed to update");
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Inventory</Title>
      <Row gutter={[16, 16]}>
        {inventory.map((item) => {
          const expiryDate = moment(item.createdAt).add(item.duration, "months");
          const daysLeft = expiryDate.diff(moment(), "days");
          return (
            <Col xs={24} sm={12} md={8} key={item._id}>
              <Card
                title={item.productName}
                extra={
                  isExpiringSoon(item) && (
                    <Tag color="red">Expires in {daysLeft} day(s)</Tag>
                  )
                }
                actions={[
                  <Button type="primary" onClick={() => handleRestockClick(item)}>
                    Restock
                  </Button>,
                ]}
              >
                <Text><strong>Type:</strong> {item.productType}</Text><br />
                <Text><strong>Qty:</strong> {item.qty}</Text><br />
                <Text><strong>Unit:</strong> {item.unit} {item.measurement}</Text><br />
                <Text><strong>Price:</strong> ₹{item.price}</Text><br />
                <Text><strong>Duration:</strong> {item.duration} month(s)</Text><br />
                <Text><strong>Created:</strong> {moment(item.createdAt).format("DD MMM YYYY")}</Text>
              </Card>
            </Col>
          );
        })}
      </Row>

      <Drawer
        title="Update Inventory"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        width={360}
      >
        <Form layout="vertical" form={form} onFinish={handleUpdate}>
          <Form.Item name="productName" label="Product Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="productType" label="Product Type" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="productCode" label="Product Code">
            <Input />
          </Form.Item>
          <Form.Item name="qty" label="Quantity" rules={[{ required: true }]}>
            <InputNumber min={1} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="unit" label="Unit" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="measurement" label="Measurement" rules={[{ required: true }]}>
            <Select>
              {["cm", "kg", "g", "L", "ml", "m"].map((m) => (
                <Option key={m} value={m}>{m}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="price" label="Price" rules={[{ required: true }]}>
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="duration" label="Duration (months)" rules={[{ required: true }]}>
            <InputNumber min={1} style={{ width: "100%" }} />
          </Form.Item>
          <Button type="primary" htmlType="submit" block>
            Update
          </Button>
        </Form>
      </Drawer>
    </div>
  );
};

export default ViewInventory;
